import { __awaiter, __generator } from "tslib";
import { Box, IconButton, Text } from '@wix/design-system';
import { useTranslation } from '@wix/wix-i18n-config';
import { ArrowUp as ArrowUpIcon } from '@wix/wix-ui-icons-common';
import React, { useEffect, useState } from 'react';
import { animateScroll } from 'react-scroll';
import { DATA_HOOKS } from '../../dataHooks';
import { withSharedComponentProviders } from '../../providers';
import { scrollToHash } from '../../utils/scroll';
import { ScrollSpy } from './ScrollSpy';
import classNames from 'classnames';
import { ConsumerSource } from '../../types';
var Anchors = function (_a) {
    var steps = _a.steps, onClick = _a.onClick, consumerSource = _a.consumerSource, containerRef = _a.containerRef, showScrollToTop = _a.showScrollToTop, hideTitle = _a.hideTitle;
    var t = useTranslation().t;
    var _b = useState(false), isScrolled = _b[0], setIsScrolled = _b[1];
    var isShowScrollToTopDefined = showScrollToTop !== undefined;
    var onAnchorClick = function (id, text, order) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            scrollToHash(id, consumerSource, containerRef);
            onClick(text, order);
            return [2 /*return*/];
        });
    }); };
    useEffect(function () {
        if (isShowScrollToTopDefined) {
            return;
        }
        var handleScroll = function () {
            setIsScrolled(window.scrollY > 0);
        };
        window.addEventListener('scroll', handleScroll);
        return function () {
            window.removeEventListener('scroll', handleScroll);
        };
    }, []);
    var onScrollToTop = function () {
        if (consumerSource === ConsumerSource.HELP_CENTER) {
            animateScroll.scrollToTop();
        }
        else if (containerRef && containerRef.current) {
            containerRef.current.scrollTo({ top: 0, behavior: 'smooth' });
        }
    };
    return steps.length > 0 ? (React.createElement(Box, { direction: 'vertical', gap: '2', className: classNames('anchors', { 'scrolled': isScrolled }), dataHook: DATA_HOOKS.ANCHORS },
        hideTitle ? null : React.createElement(Text, { size: 'small', weight: 'normal', className: "title" }, t('shared.anchors.title')),
        React.createElement(Box, null,
            React.createElement(ScrollSpy, { consumerSource: consumerSource, steps: steps, onClick: onAnchorClick }),
            (isShowScrollToTopDefined ? showScrollToTop : isScrolled) && (React.createElement(IconButton, { dataHook: DATA_HOOKS.ANCHORS_SCROLL_TO_TOP, skin: "standard", priority: "secondary", className: 'scrollToTop', onClick: onScrollToTop },
                React.createElement(ArrowUpIcon, null)))))) : null;
};
var withShredComponentsAnchors = withSharedComponentProviders(Anchors);
export { withShredComponentsAnchors as Anchors };
//# sourceMappingURL=index.js.map